import { Navigate, Route, Routes } from 'react-router-dom';
import Login from './components/Login';
import Pages from './Pages/index';
import { useContextHook } from 'use-context-hook';
import { AuthContext } from './Context/authContext';
import Signup from './components/Login/signup';
import ForgotPassword from './components/ForgotPassword';
import VerifyOtp from './Pages/verify-otp';
import ChangePassword from './components/ForgotPassword/ChangePassword';
import Successful from './components/ForgotPassword/Successful';
import OtpConfirm from './components/ForgotPassword/OtpConfirm';
import Layout from './components/Layout';
import ResearchProjectBlock from './components/ResearchProjectBlock';
import PlanSection from './components/PlanSection';
import Chat from './Pages/chat';
import EditAgent from './Pages/edit-agent';
import CreateWorkflow from './Pages/create-workflow';
import AgentDetails from './Pages/agent-details';
import CreateTool from './Pages/create-tool';
import EditTool from './Pages/edit-tool';
import DuplicateAgent from './Pages/duplicate-agent';

const Router = () => {
  function PublicRoute({ children, redirectTo, isLoggedIn }) {
    return isLoggedIn ? <Navigate to={redirectTo} /> : children;
  }

  function PrivateRoute({ children, redirectTo, isLoggedIn }) {
    return isLoggedIn ? children : <Navigate to={redirectTo} />;
  }
  const { isLoggedIn } = useContextHook(AuthContext, ['isLoggedIn']);
  const redirectTo = '/chat';

  return (
    <Routes>
      <Route
        path="/:view"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Pages />
          </PrivateRoute>
        }
      />
      <Route
        path="/chat/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <Chat />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/chat"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <Chat />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-agent/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <EditAgent />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/create-tool"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <CreateTool />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/duplicate-agent/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <DuplicateAgent />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/edit-tool/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <EditTool />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/workflows/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <CreateWorkflow />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/project/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <ResearchProjectBlock />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="/agents/:id"
        element={
          <PrivateRoute redirectTo="/" isLoggedIn={isLoggedIn}>
            <Layout showTemplate>
              <AgentDetails />
            </Layout>
          </PrivateRoute>
        }
      />

      <Route
        path="/sign-up"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <Signup />
          </PublicRoute>
        }
      />

      <Route
        path="/forgot-password"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <ForgotPassword />
          </PublicRoute>
        }
      />

      <Route
        path="/verify-otp"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <VerifyOtp />
          </PublicRoute>
        }
      />
      <Route
        path="/verify-email"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <OtpConfirm />
          </PublicRoute>
        }
      />
      <Route
        path="/change-password"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <ChangePassword />
          </PublicRoute>
        }
      />

      <Route
        path="/successful"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <Successful />
          </PublicRoute>
        }
      />
      <Route
        path="/upgrade-plan"
        element={
          <PrivateRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <Layout showTemplate>
              <PlanSection />
            </Layout>
          </PrivateRoute>
        }
      />
      <Route
        path="*"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <Login />
          </PublicRoute>
        }
      />

      <Route
        path="/login"
        element={
          <PublicRoute isLoggedIn={isLoggedIn} redirectTo={redirectTo}>
            <Login />
          </PublicRoute>
        }
      />
    </Routes>
  );
};

export default Router;
